/* global
  OLD_RIDE_FLOW_AGENCIES,
*/
import _ from 'underscore';

import Coordinate from 'common/types/Coordinate';
import {naturalSort, omitNull} from 'common/utils';


export default class AgencyInfo {
  /* eslint-disable camelcase */
  constructor({name, short_name, long_name, products, timezone, url, position}) {
    this.name = name || '';
    this.short_name = short_name || '';
    this.long_name = long_name || '';
    this.products = products || [];
    this.timezone = timezone || '';
    this.url = url || '';
    this.position = position ?
      new Coordinate(position.latitude, position.longitude) : null;
    this.old_ride_flow_enabled = _.contains(OLD_RIDE_FLOW_AGENCIES, this.name);
  }
  /* eslint-enable camelcase */

  clone() {
    return new AgencyInfo(this.serialize());
  }

  compare(other) {
    return naturalSort.compare(this.long_name, other.long_name);
  }

  serialize() {
    return omitNull({
      name: this.name,
      long_name: this.long_name,
      short_name: this.short_name,
      products: _.map(this.products, (product) => product),
      timezone: this.timezone,
      url: this.url,
      position: this.position ?
        {latitude: this.position.lat, longitude: this.position.lng} : null,
    });
  }

  isDifferent(other) {
    return !_.isEqual(this.serialize(), other.serialize());
  }
}



// WEBPACK FOOTER //
// ./src/common/types/AgencyInfo.js